module.exports = __webpack_public_path__ + "fonts/Inter-600-vietnamese61.5fc7f74.woff2";